import { colors } from '@material-ui/core';
import { ThemeMode, tokensByMode } from './tokens';

const white = '#FFFFFF';

// Era92 Creative brand colors
const era92Coral = '#fe3a6a';
const era92Orange = '#fe8c45';

// MUI derives hover/focus shades from palette values at runtime, so the
// palette needs concrete colors (CSS variables are used everywhere else).
export const createPalette = (mode: ThemeMode) => {
  const t = tokensByMode[mode];
  return {
    type: mode,
    primary: {
      contrastText: white,
      dark: '#d4183f',
      main: era92Coral,
      light: t.primaryLight,
    },
    secondary: {
      contrastText: white,
      dark: '#c46a2e',
      main: era92Orange,
      light: t.secondaryLight,
    },
    error: {
      contrastText: white,
      dark: colors.red[900],
      main: colors.red[600],
      light: colors.red[400],
    },
    text: {
      primary: t.textPrimary,
      secondary: t.textSecondary,
    },
    background: {
      default: t.bgPage,
      paper: t.bgSurface,
    },
    divider: t.divider,
    links: {
      white: '#FFFFFF',
      black: '#000000',
    },
  };
};

export default createPalette('light');
